export default __webpack_public_path__ + "static/media/more.21069a9c.png";